import React, { FC } from 'react';
import { Dayjs } from 'dayjs';
import { ReactDatePickerCustomHeaderProps } from 'react-datepicker';
import DatePickerRangeInputs from 'app/components/datepicker-dropdown/DatePickerRangeInputs';
import DatePickerHeaderMonthNav from 'app/components/datepicker-dropdown/custom-header/DatePickerHeaderMonthNav';

type Props = Pick<
  ReactDatePickerCustomHeaderProps,
  'decreaseMonth' | 'increaseMonth' | 'date'
> & {
  error: {
    startDate: boolean;
    endDate: boolean;
  };
  startDate: Dayjs | null;
  endDate: Dayjs | null;
  onStartDateChange: (date: Dayjs | null) => void;
  onEndDateChange: (date: Dayjs | null) => void;
  minDate?: Dayjs;
  maxDate?: Dayjs;
};

const DatePickerHeaderCustomPeriod: FC<Props> = ({
  decreaseMonth,
  increaseMonth,
  date,
  error,
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  minDate,
  maxDate,
}) => (
  <div className="tw-flex tw-flex-col tw-gap-y-4">
    <DatePickerRangeInputs
      error={error}
      startDate={startDate}
      endDate={endDate}
      onStartDateChange={onStartDateChange}
      onEndDateChange={onEndDateChange}
      minDate={minDate}
      maxDate={maxDate}
    />
    <DatePickerHeaderMonthNav
      date={date}
      decreaseMonth={decreaseMonth}
      increaseMonth={increaseMonth}
      minDate={minDate}
      maxDate={maxDate}
    />
  </div>
);

export default DatePickerHeaderCustomPeriod;
